import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { ArticleSection } from '../../data/articles';
interface ArticleBodyProps {
  sections: ArticleSection[];
  /** Rendered after this many sections, to place a mid-article CTA. */
  interruptAfter?: number;
  interruption?: React.ReactNode;
}
function Bullets({
  items
}: {
  items: string[];
}) {
  return <ul className="space-y-2.5 my-5" data-id="element-96" data-mp="werelc3phynn">
      {items.map(item => <li key={item} className="flex items-start" data-id="element-97" data-mp="hitpuew43wlg">
          <CheckIcon className="w-4 h-4 mr-3 mt-1 flex-shrink-0 text-navy" aria-hidden="true" data-id="element-98" data-mp="mig1wl07f6so" />
          <span className="text-gray-700 leading-relaxed" data-id="element-99" data-mp="8jyiv0l8uih3">{item}</span>
        </li>)}
    </ul>;
}
export function ArticleBody({
  sections,
  interruptAfter,
  interruption
}: ArticleBodyProps) {
  return <>
      {sections.map((section, index) => <React.Fragment key={section.id} data-id="element-100" data-mp="27vr7a8tyufi7" data-mpi={index}>
          <section id={section.id} aria-labelledby={`${section.id}-heading`} className="scroll-mt-28" data-id="element-101" data-mp="27upx06krxx1j">
            <h2 id={`${section.id}-heading`} className="text-2xl sm:text-3xl font-bold text-navy mb-4" data-id="element-102" data-mp="2ekf7p64zbl3t">
              {section.heading}
            </h2>
            {section.paragraphs?.map((paragraph, i) => <p key={i} className="text-gray-700 leading-relaxed mb-4" data-id="element-103" data-mp="2ndaguaxki0yv">
                {paragraph}
              </p>)}
            {section.bullets && <Bullets items={section.bullets} data-id="element-104" data-mp="1vlul9re193wi" />}

            {section.subsections?.map(sub => <div key={sub.heading} className="mt-8" data-id="element-105" data-mp="29l2oqwh8ay6i">
                <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-106" data-mp="29mngyfg2m517">
                  {sub.heading}
                </h3>
                {sub.paragraphs.map((paragraph, i) => <p key={i} className="text-gray-700 leading-relaxed mb-4" data-id="element-107" data-mp="3kz7rjm5ph209" data-mpi={i}>
                    {paragraph}
                  </p>)}
                {sub.bullets && <Bullets items={sub.bullets} data-id="element-108" data-mp="3o2ndprokk9wp" />}
              </div>)}
          </section>

          {interruptAfter === index + 1 && interruption}
        </React.Fragment>)}
    </>;
}